import React, { useMemo, useState } from 'react';
import { bool, func, node, oneOf, shape, string } from 'prop-types';
import { cx } from '@emotion/css';

import { styPillsContainer, styPillsText } from './style';

const Pills = (props) => {
  const {
    active: propsActive,
    children,
    className,
    disabled,
    fluid,
    onClick,
    style,
    size,
    variant,
    ...rest
  } = props;

  const isControlled = useMemo(() => propsActive !== null, [propsActive]);
  const [stateActive, setStateActive] = useState(false);

  const active = isControlled ? propsActive : stateActive;
  const styProps = {
    disabled,
    fluid,
    onClick,
    variant,
  };

  const handleClick = (event) => {
    if (!disabled) {
      if (isControlled) {
        onClick(event);
      } else {
        setStateActive(!stateActive);
      }
    }
  };

  const handleKeyDown = (event) => {
    if (!disabled) {
      if (event.key === 'Enter') {
        handleClick(event);
      }
    }
  };

  return (
    <div
      role="button"
      tabIndex="0"
      className={cx(className, active && 'active', styPillsContainer(styProps))}
      style={style}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      {...rest}
    >
      <div className={styPillsText({ size, active })}>{children}</div>
    </div>
  );
};

Pills.propTypes = {
  active: bool, // True for active, false for inactive, null for uncontrolled
  children: node,
  className: string,
  disabled: bool,
  fluid: bool,
  onClick: func,
  style: shape({}),
  size: oneOf(['sm', 'lg']),
  variant: oneOf(['outline', 'naked']),
};

Pills.defaultProps = {
  active: null,
  children: null,
  className: '',
  disabled: false,
  fluid: false,
  onClick: null,
  style: {},
  size: 'sm',
  variant: 'outline',
};

export default Pills;
